import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BreakTimeModal } from '../features/BreakTime';

/**
 * Standalone Break Page - renders the BreakTimeModal in fullscreen mode
 * Accessible at /break route for an immersive break experience
 * Supports ?activity=breathing|weather|beach|drawing|sorting|tea query parameter
 */
const BreakPage = () => {
  const [searchParams] = useSearchParams();
  const initialActivity = searchParams.get('activity');
  
  const handleClose = () => {
    // Navigate back or to home when closing
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/dashboard';
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700">
      <BreakTimeModal isOpen={true} onClose={handleClose} initialActivity={initialActivity} />
    </div>
  );
};

export default BreakPage;
